import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import { Action, DefaultPerPageValue, PerPage, Role } from "../../constants/Common";
import Loader from "../../Components/Common/Loader";
import NodataFound from "../../Components/Common/NoDataFound";
import userImage from "../../assets/images/icons/ticket.png";
import { Helmet } from "react-helmet";
import { filter } from "lodash/collection";
import { get } from "lodash/object";
import { getIconPath } from "../../helpers/file_helper";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { withTranslation } from "react-i18next";
import Search from "../../Components/casp/common/Search";
import { Button, Drawer, Tooltip } from "@mui/material";
import { getAllDeliverableList, getDeliverableDetails } from "../../api/casp/deliverable";
import EditDeliverable from "../../Components/ProjectSubmission/editDeliverable";
import CreateDeliverable from "../../Components/casp/deliverable/CreateDeliverable";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { hasModulePermission } from "../../helpers/permission";
import { Modules } from "../../constants/Module";
import moment from "moment";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EditIcon from "../../assets/images/icons/edit-line.svg"
import { useSelector } from "react-redux";

const DeliverableList = (props) => {

  const [deliverables, setDeliverables] = useState([]);
  const [selectedDeliverable, setSelectedDeliverable] = useState();
  const [page, setPage] = useState(0);
  const [action, setAction] = useState()
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
  const [rowCount, setRowCount] = useState(0);
  const [deliverableCount, setDeliverableCount] = useState(0);
  const [triggerData, setTriggerData] = useState(+new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const loggedInUser = useSelector((state) => state.Profile.user);
  // const [status, setStatus] = useState()
  const [filterData, setFilterData] = useState({
    filterFields: [],
    filterInputs: []
  })
  // const [projectDetails, setProjectDetails] = useState()
  // const loggedInUser = useSelector((state) => state.Profile.user);
  // const [project, setProject] = useState();
  // const [projectList, setProjectList] = useState([]);
  // const [searchedTerm, setSearchedTerm] = useState(null)
  // const [refreshKey, setRefreshKey] = useState(0);
  const [refresh, setRefresh] = useState();
  const [disabled, setDisabled] = useState(false);
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
  const [portfolio, setPortfolio] = useState()

  const hasCreatePermissionForDeliverable = hasModulePermission(Modules.DELIVERABLE, Action.CREATE)
  // const hasViewPermissionForDeliverable = hasModulePermission(Modules.DELIVERABLE, Action.VIEW)
  const hasEditPermissionForDeliverable = hasModulePermission(Modules.DELIVERABLE, Action.EDIT)
  const hasDeletePermissionForDeliverable = hasModulePermission(Modules.DELIVERABLE, Action.DELETE)

  const columns = [
    // index
    {
      field: "index",
      headerName: "#",
      width: 85,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <div className="MuiDataGrid-cellContent">{params.row?.indexNo}</div>
        </div>
      ),
    },
    // deliverable name
    {
      field: "deliverableName",
      headerName: props.t("Deliverable Name"),
      width: 500,
      filterable: false,
      sortable: false,
      // renderCell: (params) => (
      //   <span
      //     className="deliverableName"
      //     style={{ cursor: 'pointer' }}
      //     onClick={(e) => {
      //       fetchDeliverableDetails(params.row)
      //     }}
      //   >
      //     {params.row?.deliverableName}
      //   </span>
      // ),
    },
    // project id
    // {
    //   field: "projectUniqueId",
    //   headerName: props.t("Startup ID"),
    //   width: 200,
    //   filterable: false,
    //   sortable: false,
    // },
    // project name
    // {
    //   field: "projectName",
    //   headerName: props.t("Startup Name"),
    //   width: 300,
    //   filterable: false,
    //   sortable: false,
    // },
    // status
    // {
    //   field: "status",
    //   headerName: props.t("Status of Deliverable"),
    //   width: 300,
    //   filterable: false,
    //   sortable: false,
    // },
    // start date
    // {
    //   field: "startDate",
    //   headerName: props.t("Start Date of Deliverable"),
    //   width: 300,
    //   filterable: false,
    //   sortable: false,
    // },
    // end date
    // {
    //   field: "endDate",
    //   headerName: props.t("End Date of Deliverable"),
    //   width: 300,
    //   filterable: false,
    //   sortable: false,
    // },
    // milestone number
    // {
    //   field: "milestoneNumber",
    //   headerName: props.t("Number of Milestones"),
    //   width: 300,
    //   filterable: false,
    //   sortable: false,
    // }
    {
      field: "deliverableWeight",
      headerName: props.t("Weight"),
      width: 500,
      filterable: false,
      sortable: false
    }
  ];


  const [columnData, setColumnData] = useState([...columns])

  useEffect(() => {
    // if (hasEditPermissionForDeliverable || hasDeletePermissionForDeliverable) {
    if (hasEditPermissionForDeliverable) {
      setColumnData((prev) =>
        [
          ...columns,
          {
            field: "actions",
            headerName: props.t("Actions"),
            width: 300,
            sortable: false,
            filterable: false,
            hideable: false,
            renderCell: (params) => (
              (
                <div style={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}>
                  <div className="newActionIcons">
                    {/* {hasViewPermissionForDeliverable &&
                      <Tooltip title={props.t("View Deliverables")}>
                        <RemoveRedEyeOutlinedIcon
                          style={{ cursor: "pointer", fill: '#6B7083' }}
                          onClick={(e) => {
                            setAction(Action.VIEW)
                            fetchDeliverableDetails(params.row)
                          }}
                        />
                      </Tooltip>
                    } */}
                    {hasEditPermissionForDeliverable &&
                      <Tooltip title={props.t("Edit Deliverables")}>
                        <EditOutlinedIcon style={{ fill: '#6B7083' }}
                          onClick={(e) => {
                            setAction(Action.EDIT)
                            fetchDeliverableDetails(params.row)
                          }}
                        >
                          <img src={EditIcon} alt={EditIcon} />
                        </EditOutlinedIcon>
                      </Tooltip>
                    }
                    {/* {hasDeletePermissionForDeliverable &&
                      <Tooltip title={props.t("Delete Deliverables")}>
                        <DeleteOutlineOutlinedIcon
                          sx={{
                            cursor: "pointer",
                            ...(!disabled && {
                              "&:hover": {
                                color: "#F07676",
                              },
                            }),
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleClickDelete(params.row, Action.DELETE);
                          }}
                        />
                      </Tooltip>
                    } */}
                  </div>
                </div>
              )
            ),
          },
        ]
      )
    }

    // if (!hasEditPermissionForDeliverable && !hasDeletePermissionForDeliverable) {
    if (!hasEditPermissionForDeliverable) {
      setColumnData([...columns])
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasEditPermissionForDeliverable, localStorage.getItem("I18N_LANGUAGE")])

  useEffect(() => {
    fetchDeliverableList({ page: page + 1, perPage: rowsPerPage, ...filterData });
    // fetchProjectList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerData, refresh])


  async function fetchDeliverableDetails(selectedRow) {
    // const projectDetail = await (await getProjectDetails(selectedRow.projectId)).data.data
    // setProjectDetails(projectDetail)
    // let query = {
    //   projectId: selectedRow.projectId
    // }
    const deliverableDetails = await (await getDeliverableDetails(selectedRow.id)).data.data
    setSelectedDeliverable(deliverableDetails)
    setDrawerOpen(true)

  }

  const handleCloseDrawer = (_, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    setDrawerOpen(false);
    setSelectedDeliverable();
    setAction()
  };

  const fetchDeliverableList = async (queryParams) => {
    try {
      setIsLoading(true);
      let params = {
        ...queryParams,
        ...(search && { search }),
        // projectStatus: ProjectStatuses.ONGOING,
        // perPage: rowsPerPage,
        // page: page + 1,
      }
      const res = (await getAllDeliverableList(params)).data.data;
      setDeliverableCount(res.data.length)
      if (res.data.length >= 6) {
        setDisabled(true)
      } else {
        setDisabled(false)
      }

      // Sort deliverables by createdAt (earliest first)
      const sortedData = res.data.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
      const totalDeliverables = sortedData.length;

      let level = (params?.page + 1 - 1) * params?.perPage;
      const resultData = await Promise.all(sortedData.map(async (res, idx) => {
        let deliverableWeight = 0;

        // // First one gets weight 0, rest divide 100 equally
        if (idx !== 0 && totalDeliverables > 1) {
          deliverableWeight = 100 / (totalDeliverables - 1);
        }
        return {
          id: res.id,
          indexNo: ++level,
          // projectUniqueId: res.project.uniqueProjectId,
          // projectName: res.project.name,
          // projectId: res.project.id,
          deliverableName: res.name,
          startDate: moment(res.startDate).format("Do MMMM, YYYY"),
          endDate: moment(res.endDate).format("Do MMMM, YYYY"),
          // status: props.t(res.currentStatus),
          // milestoneNumber: res._count.milestones
          deliverableWeight: parseFloat(deliverableWeight.toFixed(2))
        };
      }));

      setDeliverables(resultData);
      setRowCount(res.meta.total);
      setIsLoading(false);
    } catch (error) {
      console.error("Failed to fetch deliverable list:", error);
      setIsLoading(false);
    }
  }

  // const fetchProjectList = async () => {
  //   try {
  //     setIsLoading(true);
  //     let params = {
  //       filterFields: ["status"],
  //       filterInputs: [ProjectStatuses.ONGOING]
  //     }
  //     const res = (await getAllProject(params)).data.data;
  //     const resultData = res.data.map((res) => {
  //       return res.name
  //     });
  //     setProjectList(resultData)

  //     setIsLoading(false);
  //   } catch (error) {
  //     console.error("Failed to fetch project list:", error);
  //     setIsLoading(false);
  //   }
  // }

  // const handleProjectChange = async (_, item) => {
  //   if (item == null) {
  //     setFilterData(prevFilter => {
  //       const updatedFilterFields = prevFilter.filterFields.filter(field => field !== "project");
  //       const updatedFilterInputs = prevFilter.filterInputs.filter((_, index) => index !== prevFilter.filterFields.indexOf("project"));

  //       return {
  //         filterFields: updatedFilterFields,
  //         filterInputs: updatedFilterInputs
  //       };
  //     });
  //   } else {
  //     setFilterData(prevFilter => {
  //       return {
  //         filterFields: [...prevFilter.filterFields, "project"],
  //         filterInputs: [...prevFilter.filterInputs, item]
  //       };
  //     });
  //   }
  //   setTriggerData(+new Date());
  // }

  const deliverableRefresh = async (cost) => {
    // fetchDeliverableList()
    setTriggerData(+new Date())
  };

  // const handleStatusChange = async (_, item) => {
  //   if (item == null) {
  //     setFilterData(prevFilter => {
  //       const updatedFilterFields = prevFilter.filterFields.filter(field => field !== "currentStatus");
  //       const updatedFilterInputs = prevFilter.filterInputs.filter((_, index) => index !== prevFilter.filterFields.indexOf("currentStatus"));

  //       return {
  //         filterFields: updatedFilterFields,
  //         filterInputs: updatedFilterInputs
  //       };
  //     });
  //   } else {
  //     setFilterData(prevFilter => {
  //       return {
  //         filterFields: [...prevFilter.filterFields, "currentStatus"],
  //         filterInputs: [...prevFilter.filterInputs, item]
  //       };
  //     });
  //   }
  //   setTriggerData(+new Date());
  // }

  // Global Search


  // const handleClickDelete = (params, action) => {
  //   if (action === Action.DELETE) {
  //     setSelectedDeliverable(params);
  //     setIsOpenSweetAlert(true);
  //   }
  // }


  // const deleteDeliverable = async () => {
  //   try {
  //     const res = await removeDeliverable(selectedDeliverable.id)
  //     if (res.statusCode === 200) {
  //       toast.success(res.data.message)
  //       // Reset to first page after deletion if needed, or adjust logic
  //       // if (deliverableList.length === 1 && page > 0) {
  //       //   setPage(page - 1); // Go to previous page if last item deleted
  //       // } else {
  //       // }
  //       setTriggerData(+new Date())// Refresh current page
  //       // setDeliverableList([]) // Clear list before refetch
  //     }
  //   } catch (err) {
  //     toast.error(err.message)
  //   }
  //   finally {
  //     setIsOpenSweetAlert(false)
  //   }
  // }

  const globalSearch = async (params) => {
    setSearch(params.search);
    // if (params?.page) {
    //   setPage(params.page);
    // }
    await fetchDeliverableList(params);
  };

  const getRowId = (row) => row.id;
  const paginationModelMethod = async (data) => {
    setPage(data.page);
    setRowsPerPage(data.pageSize);
    setTriggerData(+new Date());
  };

  const [rightDrawer, setRightDrawer] = useState({
    right: false
  });

  const toggleDrawer = (anchor, open) => (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setRightDrawer({ ...rightDrawer, [anchor]: open });
  };


  return (
    <React.Fragment>
      <div className="page-content position-relative">
        <Helmet
          onChangeClientState={(newState, addedTags) => {
            try {
              // Check if we added any new link[rel="icon"] elements.
              const newFaviconElems = filter(get(newState, "linkTags", []), {
                rel: "icon",
              });

              if (!newFaviconElems.length) {
                return;
              }

              // Get the href of the last link element we just added, which
              // we assume is the most recently-added favicon.
              const newFaviconHref =
                newFaviconElems[newFaviconElems.length - 1].href;

              // Remove all react-helmet link elements with rel="icon" that
              // do not have the href of our recently-added favicon.
              // If no other favicon elements exist, we don't have to do
              // anything.
              const existingFavicons = document.querySelectorAll(
                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
              );

              if (existingFavicons.length) {
                existingFavicons.forEach((e) => e.parentNode.removeChild(e));
              }

              // Remove and re-add the latest link element to make sure
              // the browser uses it.
              const newFaviconElem = document.querySelector(
                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
              );
              const iconToShow = <ManageAccountsIcon />;
              //<i className={'ri-git-pull-request-line'}></i>

              if (newFaviconElem) {
                const newFavElement = newFaviconElem.cloneNode(true);
                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(
                    iconToShow
                  )}</svg>`
                )}`;
                const parentElem = newFaviconElem.parentNode;
                parentElem.removeChild(newFaviconElem);
                parentElem.appendChild(newFavElement);
              }
            } catch (e) {
              console.error(e);
            }
          }}
        >
          <title>{props.t("Deliverable List")}</title>
        </Helmet>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <div className="mainPageHeader d-flex justify-content-between">
              <BreadCrumb title={props.t("Deliverable Settings")} />
            </div>
            <div className="d-flex justify-content-end gap-2 ongoingSearchField">
              {/* <div className="me-2">
                <Autocomplete
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={status}
                  size="small"
                  sx={{ width: "200px" }}
                  options={Object.values(DeliverableStatus)}
                  onChange={handleStatusChange}
                  renderInput={(params) => <TextField {...params}
                    label={props.t("Status")}
                  />}
                />
              </div>
              <div className="me-2">
                <SearchDropDownListPaginationComponent
                  label={props.t("Startup Name")}
                  searchEnabled={false}
                  disableClearable={!project}
                  listCall={getAllProject}
                  defaultValue={project}
                  sx={{ width: "200px" }}
                  emitItem={(newValue) => {
                    setProject(newValue);
                    if (newValue) {
                      setFilterData({
                        filterFields: ["project"],
                        filterInputs: [newValue.name]
                      })
                    } else {
                      setFilterData({
                        filterFields: [],
                        filterInputs: []
                      })
                    }
                    setTriggerData(+new Date());
                  }}
                  apiParams={searchedTerm && searchedTerm !== "undefined" ? {
                    filterFields: ["name", "status"],
                    filterInputs: [searchedTerm, ProjectStatuses.ONGOING]
                  } : {
                    filterFields: ["status"],
                    filterInputs: [ProjectStatuses.ONGOING]
                  }}
                  handleInputChange={(data) => setSearchedTerm(data)}
                />
              </div> */}
              {/* <div className="me-2">
                <SearchDropDownPaginationList
                  label={props.t("Cohort")}
                  sx={{
                    width: 200,
                  }}
                  disabled={isLoading}
                  searchEnabled={false}
                  listCall={getAllPortfolios}
                  disableClearable={!portfolio}
                  defaultValue={portfolio}
                  apiParams={{
                    order: "updatedAt",
                    direction: "desc",
                    ...(![
                      Role.PROJECT_MANAGER,
                      Role.EPMO_MANAGER,
                      Role.ROOT_ADMIN,
                      Role.VICE_PRESIDENT,
                      Role.PRESIDENT,
                      Role.PROGRAM_MANAGER,
                      Role.EPMO_OFFICER,
                      Role.MENTOR
                    ].includes(loggedInUser?.role?.name) && {
                      filterFields: "portfolioUser",
                      filterInputs: loggedInUser.id,
                    }),
                  }}
                  emitItem={(newValue) => {
                    setPortfolio(newValue);
                    setFilterData(prev => {
                      const newFields = [...prev.filterFields];
                      const newInputs = [...prev.filterInputs];

                      const index = newFields.indexOf("portfolioId");

                      if (index !== -1) {
                        newFields.splice(index, 1);
                        newInputs.splice(index, 1);
                      }

                      if (newValue) {
                        newFields.push("portfolioId");
                        newInputs.push(newValue.id);
                      }

                      return { filterFields: newFields, filterInputs: newInputs };
                    });

                    setPage(0)

                    setTriggerData(+new Date());
                  }}

                />
              </div> */}
              <div className="position-relative">
                <Search
                  listCall={globalSearch}
                  params={{
                    ...(props?.status ? {
                      filterFields: ["status"],
                      filterInputs: [props.status]
                    } : {}),
                    page: 1,
                    perPage: rowsPerPage,
                  }}
                />
                {/* <SearchOutlinedIcon /> */}
              </div>
              <div className="mainPageHeader d-flex justify-content-between">
                {
                  hasCreatePermissionForDeliverable && (
                    <>
                      {deliverableCount >= 6 ? (
                        <Tooltip title="Cannot add more than 6 deliverables" placement="bottom">
                          <span>
                            <Button
                              variant="contained"
                              className="popupButton edit_button main-login-btn d-flex align-items-center btn btn-secondary m-0"
                              disableElevation
                              disabled
                            >
                              <AddOutlinedIcon /> &nbsp; {props.t("Deliverables")}
                            </Button>
                          </span>
                        </Tooltip>

                      ) : (
                        <Button
                          variant="contained"
                          className="popupButton edit_button main-login-btn d-flex align-items-center btn btn-secondary m-0"
                          disableElevation
                          onClick={toggleDrawer("right", true)}
                          disabled={disabled}
                        >
                          <AddOutlinedIcon /> &nbsp; {props.t("Deliverables")}
                        </Button>
                      )}
                    </>
                  )}
              </div>
            </div>
          </div>
          <div className="accordionTable my-4" style={{ width: "100%" }}>
            {deliverables.length > 0 && (
              <DataGrid
                // key={refreshKey}
                rows={deliverables}
                columns={columnData}
                disableRowSelectionOnClick
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: rowsPerPage },
                  },
                }}
                paginationMode="server"
                onPaginationModelChange={paginationModelMethod}
                rowCount={rowCount}
                pageSizeOptions={PerPage}
                getRowId={getRowId}
                loading={isLoading}
                // onRowSelectionModelChange={(e) => setIsSendMsg({ data: e, status: false })}
                // checkboxSelection={loggedInUser?.role?.name === Role.EPMO_OFFICER}
                localeText={{
                  MuiTablePagination: {
                    labelRowsPerPage: props.t("Rows per page:"),
                  },
                }}
              />
            )}
            {drawerOpen && selectedDeliverable &&
              <EditDeliverable
                isOpen={drawerOpen}
                handleClose={handleCloseDrawer}
                selectedRow={selectedDeliverable}
                refresh={deliverableRefresh}
                isDisabled={false}
                action={action}
              // projectDetails={projectDetails}
              />
            }
            {/* {isOpenSweetAlert && (
              <SweetAlert
                title={t("Are you sure want to delete this deliverable") + "?"}
                warning
                showCancel
                confirmBtnText={t("OK")}
                cancelBtnText={t("Cancel")}
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={async () => {
                  await deleteDeliverable();
                }}
                onCancel={() => {
                  setIsOpenSweetAlert(false);
                }}
              ></SweetAlert>
            )} */}
            {deliverables.length === 0 && isLoading && <Loader />}
            {deliverables.length === 0 && !isLoading && (
              <NodataFound text={props.t("No deliverables to show")} icon={userImage} />
            )}
          </div>
        </Container>
      </div>

      <Drawer
        anchor="right"
        open={rightDrawer.right}
        onClose={toggleDrawer("right", false)}
        PaperProps={{
          sx: { width: "580px" },
        }}
        className="projectListDrawer"
      >
        {
          deliverableCount === 6 && <div>
            "Cannot add more than 6 deliverables"
          </div>
        }
        {
          // projectDetails && (
          <CreateDeliverable
            isOpen={rightDrawer.right}
            setIsOpen={toggleDrawer("right", false)}
            refresh={deliverableRefresh}
          // emitProject={setRefresh}
          // projectCost={projectDetails.projectCost}
          // projectStartDate={dayjs(projectDetails.startDate).format(
          //   "YYYY-MM-DD"
          // )}
          // projectEndDate={dayjs(projectDetails.endDate).format("YYYY-MM-DD")}
          />
          // )
        }
      </Drawer>

    </React.Fragment>
  );
}

export default withTranslation()(DeliverableList)
